import { create } from "zustand";

/**
 * Guidance Store State
 */
type GuidanceStateType = {
  progressValue: number;
  setProgressValue: (value: number) => void;
  resetProgress: () => void;
};

/**
 * Zustand store for managing guidance details page progress
 * Replaces: guidanceDetailsProgressAtom from recLib/atoms/guidance.ts
 */
export const useGuidanceStore = create<GuidanceStateType>((set) => ({
  // Initial state - 0% progress
  progressValue: 0,

  // Set the progress value
  setProgressValue: (value) => set({ progressValue: value }),

  // Reset progress to 0
  resetProgress: () => set({ progressValue: 0 }),
}));
